import * as React from 'react';
import styled from 'styled-components';
import { PageBlocksView } from '../../design-object-blocks-views/page-blocks.view';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { NotFoundPage } from '../404';
import { ColorEnum } from '../../../enum/color.enum';
import Translate from '../../translate/translate';
import { joinUrl } from '../../../util/url/join-url.util';
import { LAYERS_DIV_ID } from '../../../constants';
import { getPageURI } from '../../../util/url/get-page-uri.util';
import { DesignTypeEnum } from '../../../enum/design-type.enum';
import { draftToString } from '../../../util/draft/draft-to-string.util';
import { isPageModel } from '../../../util/design-object/is-page-model.util';
import { SmartLink } from '../../smart-link/smart-link';

const HomeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props: { hasWarning: boolean }) => props.hasWarning ? 'padding-bottom: 20px;' : ''}
`;

const DraftWarning = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  text-align: center;
  background-color: ${ColorEnum.Red};
  z-index: 10000;
`;

const DraftWarningLink = styled(SmartLink)`
  color: ${ColorEnum.White} !important;
  text-decoration: none;
`;

// DON"T ADD 100% or 100vh here it will block all input from user
const LayersDiv = styled.div`
    width:100%;
    position:fixed;
    left:0;
    top:0;
    z-index: 15000;
`;

@inject('state', 'dispatch')
@observer
export class HomePage extends React.Component<{ route } & IInjectedProps> {
  loadPageDraft = () => {
    if (this.props.state.activeDesign.data && !this.props.state.activeDesign.data.isDraft
      && this.props.state.activeDesign.data.type === DesignTypeEnum.Page) {
      this.props.dispatch.loadDesignObjectDraft(this.props.state.activeDesign.data);
    } else if (!this.props.state.activeDesign.data) {
      this.props.dispatch.loadNewDesignObjectDraft();
    }
  }

  componentDidMount() {
    this.loadPageDraft();
  }

  componentWillReact = () => {
    this.loadPageDraft();
  }

  render() {
    let view;
    let warning;
    if (isPageModel(this.props.state.activeDesign.data)) {
      view = <PageBlocksView page={this.props.state.activeDesign.data}/>;
      if (this.props.state.activeDesign.data.isDraft && !this.props.state.configuration.isPreview) {
        warning = <DraftWarning>
          <DraftWarningLink
            to={this.props.state.activeDesign.data.isNew ? '/admin/pages/new-page' : joinUrl('/admin/pages', getPageURI(Object.assign({}, this.props.state.activeDesign.data, {title: draftToString(this.props.state.activeDesign.data.ogTitle || this.props.state.activeDesign.data.title, this.props.state)})))}
          >
            <Translate>cms.draft-page-warning</Translate>
          </DraftWarningLink>
        </DraftWarning>;
      }
    }
    return this.props.state.activeDesign.data ? <HomeWrapper hasWarning={this.props.state.activeDesign.data.isDraft}>
      {view}
      <LayersDiv id={LAYERS_DIV_ID}/>
      {warning}
    </HomeWrapper> : <NotFoundPage/>;
  }
}
